import { NaniumObject, Type } from "nanium/objects";

export class LifeHack extends NaniumObject<LifeHack> {
  static strictDefault: boolean = true;

  @Type(String) id?: string;
  @Type(String) name?: string;
  @Type(String) description?: string;
  @Type(String) dateCreated?: Date;

  @Type(String) owningFacility?: string;
  @Type(Number) priority?: number;
  @Type(Boolean) isActive?: boolean;
}
